<template>
  <div
    class="tad-check-row"
    role="checkbox"
    :aria-checked="modelValue"
    tabindex="0"
    @click="toggle"
    @keydown.space.prevent="toggle"
    @keydown.enter.prevent="toggle"
  >
    <div v-if="icon" class="tad-check-row__icon-wrap">
      <v-icon :icon="icon" size="20" />
    </div>
    <span class="tad-check-row__label">{{ label }}</span>
    <div
      class="tad-check-box"
      :class="{ 'tad-check-box--checked': modelValue }"
      aria-hidden="true"
    >
      <v-icon v-if="modelValue" icon="mdi-check" size="14" />
    </div>
    <input
      type="checkbox"
      class="tad-check-box__native"
      :checked="modelValue"
      tabindex="-1"
      @change="onNativeChange"
    />
  </div>
</template>

<script>
export default {
  name: "TicketActionCheckboxRow",
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, required: true },
    icon: { type: String, default: "mdi-checkbox-marked-circle-outline" },
  },
  emits: ["update:modelValue"],
  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    },
    onNativeChange(event) {
      this.$emit("update:modelValue", event.target.checked);
    },
  },
};
</script>
